const washAndIronWoman = [
	{
		id: '1201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 40,
		quantity: 1
	},
	{
		id: '1202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / Slack / Pazama)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 45,
		quantity: 1
	},
	{
		id: '1203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Scarf / Dupatta / Orna / Muffler)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 50,
		quantity: 1
	},
	{
		id: '1204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Cardigan)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 80,
		quantity: 1
	},
	{
		id: '1205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Nightdress / Normal Maxi)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 40,
		quantity: 1
	},
	{
		id: '1206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Long Dress (Borka /Jumpsuit / Arabian Dress)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 60,
		quantity: 1
	},
	{
		id: '1207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Blous / Petticoat / Under Garments)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 35,
		quantity: 1
	},
	{
		id: '1208',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain Cotton / Plain Silk / Cotton Design)',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '1209',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kameez / Kaftan / Apron / Tops',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 40,
		quantity: 1
	},
	{
		id: '1210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blazer / Coat / Jacket',
		category: "Women's Wear",
		service: 'Wash And Iron',
		price: 140,
		quantity: 1
	},
	{
		id: '1211',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree - Exclusive (Benarasi / Jamdani / Katan)',
		category: "Women's wear",
		service: 'Wash And Iron',
		price: 250,
		quantity: 1
	},
	{
		id: '1212',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Kameez',
		category: "Women's wear",
		service: 'Wash And Iron',
		price: 100,
		quantity: 1
	},
	{
		id: '1213',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Waist Coat / Coati',
		category: "Women's wear",
		service: 'Wash And Iron',
		price: 80,
		quantity: 1
	},
	{
		id: '1214',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Overcoat',
		category: "Women's wear",
		service: 'Wash And Iron',
		price: 300,
		quantity: 1
	}
];
export default washAndIronWoman;
